export enum EnumFormItemStatus {
  error = 'error',
  success = 'success',
}
